import React from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from 'utils/Loader';
import { validateOTPVerifyForm } from 'utils/validationUtils';
import useOTPVerificationController from './OTPVerificationController';
import { Grid } from '../../../node_modules/@mui/material/index';

function OTPVerification() {
  const {
    OTP,
    formData,
    errors,
    apiError,
    loading,
    handleChange,
    handleOTPverify,
    resendOTP,
    canResend,
    resendTimer,
    formatTimer,
  } = useOTPVerificationController({ otp: '' }, validateOTPVerifyForm);


  const navigate = useNavigate();

  return (
    <div className="login">
      <div className="form">
        <form onSubmit={handleOTPverify}>
          <span className="span-forwpass" style={{ color: 'white' }}>OTP Verification</span>
          <span style={{ color: 'white' }}>Your OTP: {OTP}</span>
          <input
            type="text"
            name="otp"
            placeholder="OTP"
            className="form-control inp_text"
            value={formData.otp}
            onChange={handleChange}
            style={{ marginTop: '10px' }}
          />
          <p className="error">{errors.otp}</p>

          <Grid container>
            <Grid item xs={12} sm={6}
              sx={{
                display: 'flex',
                justifyContent: { xs: 'flex-end', sm: 'flex-start' },
                marginBottom: {xs: '10px', sm: 'none'}
              }}>
              {/* Resend OTP */}
              <span
                role="button"
                tabIndex={0}
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  cursor: canResend ? 'pointer' : 'not-allowed',
                  color: canResend ? 'white' : 'gray',
                }}
                onClick={canResend ? resendOTP : undefined}
                onKeyDown={(e) => {
                  if (canResend && (e.key === 'Enter' || e.key === ' ')) {
                    resendOTP();
                  }
                }}
              >
                {canResend ? 'Resend OTP' : `Resend OTP (${formatTimer(resendTimer)})`}
              </span>
            </Grid>

            <Grid item xs={12} sm={6}>
              <span
                role="button"
                tabIndex={0}
                style={{ display: 'flex', justifyContent: 'end', cursor: 'pointer' }}
                onClick={() => navigate('/login')}
                onKeyDown={(e) => { if (e.key === 'Enter') navigate('/login'); }}
              >
                Back To Login
              </span>
            </Grid>

          </Grid>


          <div style={{ marginTop: '20px' }}>
            <p className="error">{apiError}</p>
            <button type="submit" disabled={loading}>
              {loading ? <Loader /> : 'Verify'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default OTPVerification;
